import { navigate, RouteComponentProps, useParams } from '@reach/router'
import { Button, Descriptions, message, Table } from 'antd'
import React from 'react'
import styled from 'styled-components'
import { Ad, Card, Title } from '../components/ui'
import useSWR from 'swr'
import { ColumnsType } from 'antd/lib/table'
import { api } from '../common/api'
import { parse } from 'query-string'
import { useLoading, useMedia } from '../common/hooks'
import { checkPayment } from '../services/payment'
import Fpx from '../assets/payment1.png'
import EWallet from '../assets/payment2.png'

const StyledAccountDetail = styled.div`
  padding-top: 10px;

  .scroll-item {
    height: 320px;
    color: #fff;
    line-height: 160px;
    text-align: center;
    background: #364d79;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .between {
    justify-content: space-between;
  }

  .center {
    align-items: center;
  }

  .gray {
    color: #c4c4c4 !important;
  }

  .card {
    padding: 15px;
    margin-bottom: 45px;
  }

  .status {
    float: right;
    font-size: 22px;
  }

  .info {
    min-height: 196px;

    .ant-descriptions {
      width: 100%;
    }

    .ant-descriptions-item-label {
      font-weight: bold;
    }

    .ant-descriptions-item {
      padding: 15px 0;
    }

    .info-pic {
      border-radius: 6px;
      margin-right: 10px;
      width: 177px;
      height: 127px;
    }
    .content {
      width: 100%;

      & > div {
        margin-bottom: 15px;

        & + div {
          font-weight: 500;
        }
      }
    }
  }

  .card-list {
    padding-right: 2px;
    .card {
      height: 125px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 18px;
      min-width: 240px;
      max-width: 240px;
      border-top: 10px solid transparent;
    }
    .card:last-of-type {
      margin-right: 0;
    }

    .card:nth-of-type(1) {
      border-color: rebeccapurple;
    }

    .card:nth-of-type(2) {
      border-color: chartreuse;
    }

    .card:nth-of-type(3) {
      border-color: coral;
    }

    @media (max-width: 992px) {
      .card {
        margin: 24px 0;
        width: 42vw;
        max-width: 45vw;
      }
    }
  }

  @media screen and (max-width: 1480px) and (min-width: 1000px) {
    .items {
      width: 60vw;
      margin-top: 10px;
    }
    .card {
      margin: 20px 0 !important;
    }
  }

  .make-payment {
    height: 125px;
    min-width: 260px;
    max-width: 260px;
    color: #fff;

    &::after {
      white-space: nowrap;
    }

    &.active {
      background-color: #1abcfe;
    }

    &.off {
      background-color: gray;
    }

    &.done {
      background-color: #0078d4;
    }

    h3 {
      color: #fff !important;
      margin: 0;
    }

    p {
      opacity: 0.8;
    }

    button {
      width: 100%;
    }
  }

  @media screen and (max-width: 600px) {
    .items .card {
      width: 100%;
      max-width: 90vw;
      margin: 15px auto !important;
    }
  }
`

interface Item {
  // ------Balance
  balance: string
  // ------Due Date
  dueDate: string
  // ------Amount Paid
  paidAmt: string
  // ------payment reference
  pytRef: string
  // ------Paid Mode
  paidMode: string
  // ------Paid Date
  paidDate: string
  // ------Month
  month: string
  // ------Transaction Fees
  feeAmt: string
}
interface Detail {
  brand: string
  regNo: string
  model: string
  // ---Last Instalment Date
  lstInstDate: string
  // ---Original Loan Amount (Balance)
  orgLoanAmt: string
  // ---Remaining Instalment
  remInst: string
  // ---number of month
  term: string
  totalTerms: string
  // ---Total Payment
  totalPayment: string
  // ---Late Charges
  lateCharges: string
  // ---monthly instalment
  mthInstPay: string
  // ---Account Status
  status: string
  // ---1st Instalment Date (Loan Start Date)
  fstInstDate: string
  // ---Other Charges
  otherCharges: string
  // ---Total Outstanding
  totalOutstanding: string
  transHisList: Item[]
  // Advance Payment
  balance: string
  // Ambank VA number
  ambankVA: string
}

export const AccountDetail: React.FC<RouteComponentProps> = () => {
  const { id } = useParams()
  const { regNo, brand, model } = parse(window.location.search)
  const { data } = useSWR<Detail>('/customer/acc/detail?agreementNo=' + id, api.get)
  const { loading, start, finish } = useLoading()
  const isMobile = useMedia('(max-width: 600px)')

  const redirectToPayment = async () => {
    start()
    try {
      const payload = await checkPayment(id)
      if (payload.data) navigate(`../payment/${id}`)
      else message.error(payload.message)
    } catch (err) {
      console.error(err)
      finish()
    }
  }
  // const [state, setState] = useState({
  //   // 品牌
  //   brand: 'brand name',
  //   // 型号
  //   model: 'model',
  //   // 注册号
  //   registerationNumber: 'registeration number',
  //   // 合约号
  //   agreenmentNumber: 'agreenment number',
  //   // 原始贷款金额
  //   banlance: 8000,
  //   // 总支付金额
  //   totalPaid: 2000,
  //   // 总剩余待还金额
  //   remainingInstalment: 6000,
  //   // 第一期还款日
  //   loanStartDate: '2019-12-09',
  //   // 最后一期还款日
  //   loanEndDate: '2020-12-09',
  //   // 当前应还
  //   remainPrice: 2000,
  //   // 总期数
  //   totalMonth: 12,
  //   // 当前剩余期数
  //   leftMonth: 7,
  //   // 月供金额
  //   monthPaid: 2000,
  //   // 其他费用
  //   otherCharge: 100,
  //   // 滞纳金
  //   lateCharge: 300,
  //   // 状态 有效、注销、已结清
  //   status: 0,
  // })

  // if (!data) return <Spin spinning={true}></Spin>
  return (
    <StyledAccountDetail>
      <div className="row">
        <Card className="info row">
          <Descriptions column={{ xxl: 4, xl: 3, lg: 2, md: 2, sm: 2, xs: 1 }}>
            <div>
              <Title>Account Detail</Title>
            </div>
            <Descriptions.Item label="Agreement Number">{id}</Descriptions.Item>
            {/* <Descriptions.Item label="Status">{data?.status}</Descriptions.Item> */}
            <Descriptions.Item label="Due and Payable">{data?.remInst}</Descriptions.Item>

            <Descriptions.Item label="Brand">{brand || data?.brand}</Descriptions.Item>
            <Descriptions.Item label="Model">{model || data?.model}</Descriptions.Item>
            <Descriptions.Item label="Registration Number">{regNo || data?.regNo}</Descriptions.Item>

            <Descriptions.Item label="Original Loan Amount">{data?.orgLoanAmt}</Descriptions.Item>
            <Descriptions.Item label="First Instalment Date">{data?.fstInstDate}</Descriptions.Item>
            <Descriptions.Item label="Last Instalment Date">{data?.lstInstDate}</Descriptions.Item>

            <Descriptions.Item label="Monthly Instalment">{data?.mthInstPay}</Descriptions.Item>
            <Descriptions.Item label="Late / Compensation Charge">{data?.lateCharges}</Descriptions.Item>
            <Descriptions.Item label="Other Charge">{data?.otherCharges}</Descriptions.Item>
            <Descriptions.Item label="Advance Payment">{data?.balance}</Descriptions.Item>
            <Descriptions.Item label="Ambank Collection Account">{data?.ambankVA}</Descriptions.Item>
          </Descriptions>
        </Card>
      </div>
      <div className="flex flex-col lg:flex-row justify-items-center align-center overflow-hidden">
        <div className="m-auto lg:m-0 lg:mr-5" style={isMobile ? { width: '90%' } : { width: '320px' }}>
          <Ad />
        </div>
        <div className="w-full">
          <div className="card-list flex flex-wrap justify-around lg:justify-between">
            <Card>
              <h3>Total Loan Payment</h3>
              <div>
                <span style={{ fontWeight: 'bold', fontSize: 24 }}>{data?.totalPayment}</span>
                <span className="gray">RM</span>
              </div>
            </Card>
            <Card>
              <h3>Total Outstanding</h3>
              <div>
                <span style={{ fontWeight: 'bold', fontSize: 24 }}>{data?.totalOutstanding}</span>
                <span className="gray">RM</span>
              </div>
            </Card>

            <Card>
              <h3>Remaining Instalments</h3>
              <div style={{ textAlign: 'right' }}>
                {/* 剩余期数 */}
                <span style={{ fontWeight: 'bold', fontSize: 24 }}>{data?.term}</span>
                {/* 总期数 */}
                <span className="gray"> / {data?.totalTerms} (Instalments)</span>
              </div>
            </Card>
            {data?.status !== 'CLEAR' ? (
              <Card className="make-payment active row">
                <div className="flex justify-between px-5">
                  <img className="h-12" src={Fpx} alt="fpx" />
                  <img className="h-12" src={EWallet} alt="ewallet" />
                </div>
                <Button loading={loading} onClick={redirectToPayment}>
                  Make Payment
                </Button>
              </Card>
            ) : null}
          </div>
            <div className="hidden xl:inline-block w-full">
              <Title className="mb-5">Transaction History</Title>
              <TransactionHistory data={data?.transHisList || []} />
            </div>
        </div>
      </div>
      <div className="inline-block xl:hidden w-full">
        <Title className="mb-5">Transaction History</Title>
        <TransactionHistory data={data?.transHisList || []} />
      </div>
    </StyledAccountDetail>
  )
}

const StyledTransactionHistory = styled.div`
  .card {
    padding: 0;
    overflow: scroll;
  }
  th {
    white-space: nowrap;
  }

  @media screen and (max-width: 600px) {
    .ant-table-cell-fix-left-last::after {
      box-shadow: inset 10px 0 8px -8px rgb(0 0 0 / 15%);
    }
  }
`

// const mockData = [
//   { month: 1, dueDate: '2021-12-08', paidDate: '2020-12-01', paidMode: 'FPX', reference: 'FX-1230-0123', paidAmount: 20.0, balance: 2000 },
//   { month: 2, dueDate: '2021-12-08', paidDate: '2020-11-01', paidMode: 'FPX', reference: 'FX-1230-1123', paidAmount: 20.0, balance: 2020 },
//   { month: 3, dueDate: '2021-12-08', paidDate: '2020-10-01', paidMode: 'FPX', reference: 'FX-1230-2123', paidAmount: 20.0, balance: 2040 },
//   { month: 4, dueDate: '2021-12-08', paidDate: '2020-09-01', paidMode: 'FPX', reference: 'FX-1230-3123', paidAmount: 20.0, balance: 2060 },
//   { month: 5, dueDate: '2021-12-08', paidDate: '2020-08-01', paidMode: 'FPX', reference: 'FX-1230-4123', paidAmount: 20.0, balance: 2080 },
// ]

export const TransactionHistory: React.FC<{ data: Item[] }> = ({ data }) => {
  // const isMobile = useMedia('(max-width: 600px)')
  const columns: ColumnsType<any> = [
    // { title: 'Month', dataIndex: 'month' },
    // { title: 'Due Date', dataIndex: 'dueDate' },
    { title: 'Payment Date', dataIndex: 'paidDate', fixed: 'left', width: 200 },
    { title: 'Payment Mode', dataIndex: 'paidMode' },
    { title: 'Payment Reference', dataIndex: 'pytRef' },
    { title: 'Loan Amount Paid', dataIndex: 'paidAmt' },
    { title: 'Transaction Fee', dataIndex: 'feeAmt' },
    // { title: 'Balance', dataIndex: 'balance' },
  ]
  return (
    <StyledTransactionHistory>
      <Card>
        <Table rowKey={(record) => record.paidAmt + record.pytRef} columns={columns} dataSource={data} pagination={false} locale={{ emptyText: 'No records found' }} />
      </Card>
    </StyledTransactionHistory>
  )
}
